import React, { useState } from 'react';
import { useMount } from 'ahooks';
import Cookies from 'js-cookie';
import ProductComparisonUnit from './ProductComparisonUnit';
import { InstantSearch, Configure, useHits } from 'react-instantsearch-hooks-web';
import algoliasearch from 'algoliasearch/lite';
import './ComparisonResults.scss';
import { rows } from './utils';

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_ONLY_KEY);

const ComparisonHits = (props) => {
  const { hits } = useHits();

  return (
    <>
      {rows.map((row) => {
        return (
          <tr key={row.key}>
            <th>{row.label || row.key}</th>
            {hits.map((hit) => {
              return (
                <ProductComparisonUnit
                  handleProductRemoval={props.handleProductRemoval}
                  key={`${row.key}_${hit.objectID}`}
                  row={row}
                  product={hit}
                ></ProductComparisonUnit>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};

const ProductComparisonResults = () => {
  const [selection, setSelection] = useState([]);

  useMount(() => {
    let currentSelection = Cookies.get('compareProducts');
    if (currentSelection) {
      setSelection(JSON.parse(currentSelection));
    }
    window.theme_app.on('product-compare-update', (state) => {
      setSelection(state.compareProducts);
    });
  });

  const handleProductRemoval = (handle) => {
    let newSelection = selection.filter((item) => item !== handle);
    window.theme_app.emit('product-compare-update', { compareProducts: [...new Set(newSelection)] });
    Cookies.set('compareProducts', JSON.stringify(newSelection));
  };

  let formattedQuery = selection.map((item) => `handle:"${item}"`);

  if (!selection.length) {
    return (
      <div className="Main">
        <header className="Main__header" data-container>
          <h1>Compare Products</h1>
        </header>
        <div className="Main__content" data-container="narrowest">
          <p>
            No products selected for comparison. <a href={`/products/`}>Click here</a> to navigate to our catalogue and select products for
            comparison using the option "Add to Compare" available next to each product.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="Main">
      <header className="Main__header" data-container>
        <h1>Compare Products</h1>
      </header>
      <div className="Main__content">
        <InstantSearch searchClient={searchClient} indexName="shopify_products">
          <Configure filters={formattedQuery.join(' OR ')} distinct />
          <div className="ComparisonResultsWrapper">
            <div className="ComparisonResults">
              <table>
                <tbody>
                  <ComparisonHits handleProductRemoval={handleProductRemoval}></ComparisonHits>
                </tbody>
              </table>
            </div>
          </div>
        </InstantSearch>
      </div>
    </div>
  );
};

export default ProductComparisonResults;
